export class WlChange extends CustomEvent<EventInit> {

    static type: string = 'wl-change';

    constructor() {
        super(WlChange.type, {bubbles: true, composed: true});
    }
}